import script from "./base-switch.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-switch.vue?vue&type=script&setup=true&lang=ts"

import "./base-switch.vue?vue&type=style&index=0&id=045a8a2e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-045a8a2e"]])

export default __exports__